import { Injectable } from '@angular/core';
import { AuthRedirectService } from '@spartacus/core';
import { take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AimoAuthRedirectService extends AuthRedirectService {
    setRedirectUrl(url: string) {
        if (url?.indexOf('followExternalRedirects=true') >= 0) {
            super.setRedirectUrl(url);
        }
    }

    redirect(): void {
        //redirection triggered from AimoLoginFormComponentService
    }

    aimoRedirect(): void {
        this.authRedirectStorageService
            .getRedirectUrl()
            .pipe(take(1))
            .subscribe((redirectUrl) => {
                if (redirectUrl === undefined) {
                    this.routing.go('/');
                } else {
                    this.routing.goByUrl(redirectUrl.replace('followExternalRedirects=true', ''));
                }
                this.clearRedirectUrl();
            });
    }
}
